angular.
module("dx.webapp.integrations").
controller("DxSAMLIntegrationsController", function SAMLIntegrationsController(
	$filter,
	$window,

	dxApi,
	DX_SAML_INTEGRATION_TYPE,
	DX_UPLOAD_STATE,
	DxSAMLIdentityProvider,

	dxLocalize
) {
	"use strict";

	var self = this;

	self.DX_SAML_INTEGRATION_TYPE = DX_SAML_INTEGRATION_TYPE;
	self.DX_UPLOAD_STATE = DX_UPLOAD_STATE;

	self.samlEnabled = false;
	self.isConnected = false;
	self.skolFederationIDPs = [];
	self.selectedIdp = null;
	self.integrationType = DX_SAML_INTEGRATION_TYPE.OTHER;

	self.uploadUrl = dxApi.v1.nodes.saml.identityProviders.url(self.nodeId);
	self.uploadControl = {};

	self.helpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/sections/360001785353-SAML" :
		"https://support.digiexam.se/hc/en-us/sections/360001785353-SAML";

	self.$onInit = function onInit() {
		dxApi.v1.nodes.saml.identityProviders.get(self.nodeId).then(idpUpdated, onErrorResponse);
		dxApi.v1.saml.identityProviders.get(DX_SAML_INTEGRATION_TYPE.SKOLFEDERATION).then(loadListResolve, onErrorResponse);
	};

	function idpUpdated(response) {
		self.identityProvider = response.data;

		if (self.identityProvider) {
			self.identityProvider.identityProviderXml = $window.atob(self.identityProvider.identityProviderXml);
			self.samlEnabled = self.isConnected = self.identityProvider.enabled;
			self.identityProvider.formattedValidUntil = self.identityProvider.validUntil.toLocaleString();
		} else {
			self.samlEnabled = self.isConnected = false;
		}

		self.errorMessage = "";
	}

	function onErrorResponse(response) {
		if (response.status === 403) {
			self.errorMessage = dxLocalize.get("Integrations.SAML.Error.403");
		} else if (response.status === 409) {
			self.errorMessage = dxLocalize.get("Integrations.SAML.IDPAlreadyInUse");
		} else {
			self.errorMessage = dxLocalize.get("Integrations.SAML.Error.Unhandled");
		}
	}

	function loadListResolve(response) {
		var idpList = response.data;

		var language = dxLocalize.getLanguage();

		for (var i = 0; i < idpList.length; i++) {
			var idp = idpList[i];

			if (language === "sv") {
				idp.name = idp.organizationNameSV || idp.organizationNameEN || idp.entityId;
			} else {
				idp.name = idp.organizationNameEN || idp.organizationNameSV || idp.entityId;
			}
		}

		self.skolFederationIDPs = $filter("orderBy")(idpList, "name");
	}

	self.enableSAML = function enableSAML() {
		if (self.identityProvider) {
			dxApi.v1.nodes.saml.identityProviders.put(self.nodeId, true, null, null).
				then(idpUpdated, onErrorResponse);
		} else {
			self.samlEnabled = true;
		}
	};

	self.saveSelectedIdp = function saveSelectedIdp() {
		dxApi.v1.nodes.saml.identityProviders.put(self.nodeId, true, self.selectedIdp.entityId, self.nodeUnitId).
			then(idpUpdated, onErrorResponse);
	};

	self.disableSAML = function disableSAML() {
		if (self.isConnected) {
			dxApi.v1.nodes.saml.identityProviders.put(self.nodeId, false).
				then(idpUpdated, onErrorResponse);
		} else {
			self.samlEnabled = false;
		}
	};

	self.removeIdp = function removeIdp() {
		dxApi.v1.nodes.saml.identityProviders.delete(self.nodeId).then(idpUpdated, onErrorResponse);
	};

	self.upload = function upload() {
		self.uploadControl.formData = {unitId: self.nodeUnitId};
		self.uploadControl.upload();
	};

	self.onFileUploaded = function onFileUploaded(item, response, status) {
		if (status === 200) {
			idpUpdated({data: new DxSAMLIdentityProvider(response)});
		} else {
			onErrorResponse({status: status});
		}
	};

	self.onCompleteAll = function onCompleteAll() {
		self.uploadControl.reset();
	};
});
